import React, { useEffect, useState, useRef } from "react";
import "./listBlog.css";
import "./filter.css";
import { blog12 } from "../../assets/data/12Blog";
import { useCounter } from "../../hooks/useCounter";
import { useTranslation } from "react-i18next";
import { useAxios } from "../../hooks/useAxios";
import { useAxios3 } from "../../hooks/useAxios";
import FilterMenu from "../FilterMenu/FilterMenu";

import Busqueda_cont from "./busqueda";

import rel from "../../assets/img/relo.png";
import ir from "../../assets/img/ir_acti.png";
import regresa from "../../assets/img/regresa.png";
import regresa2 from "../../assets/img/ir_izq.png";
import lupa from "../../assets/img/lupa.png";
import flec from "../../assets/img/flech_abaj.png";
import liber from "../../assets/img/liber.svg";
import edu from "../../assets/img/educ.svg";
import arte from "../../assets/img/arte.svg";
import lider from "../../assets/img/lider.svg";
import inov from "../../assets/img/inov.svg";
import dere from "../../assets/img/estad.svg";
import prosp from "../../assets/img/prosp.svg";
import biblio from "../../assets/img/bibli.svg";
import medio from "../../assets/img/medio.svg";

import arrowDownIcon from "../../assets/img/flech_abaj.png";
import parse from "html-react-parser";
import { Tooltip } from "react-tooltip";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

const countBlog = 370;
//const pagin = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const ListBlog = () => {
  const [t, i18n] = useTranslation("ideas_libertad");
  const [t2] = useTranslation("biblioteca");
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const categoria = queryParams.get("categoria");

  const { counter, increment, decrement, resetCounter, defaultValue } =
    useCounter(0);

  const [toppage, setToppage] = useState(10);
  const [toppage_mov, setToppage_mov] = useState(4);
  const [ficha, setFicha] = useState(12);

  const [txtbusqueda, setTxtbusqueda] = useState("");

  const [url2, setUrl2] = useState(
    categoria
      ? `/blogs/by-category/${categoria}?offset=0&next=1200&lang=${i18n.language}`
      : `/blogs/n?offset=0&next=1201&lang=${i18n.language}`
  );

  const [url, setUrl] = useState(
    `/blogs/n?offset=${counter * ficha}&next=12&lang=${i18n.language}`
  );

  const [variableRetornada, setVariableRetornada] = useState(null);

  const handleRetorno = (valor) => {
    setVariableRetornada(valor);
  };

  const [category, setCategory] = useState(
    categoria
      ? `${categoria}`
      : null
  );

  const [date, setDate] = useState(null);

  const { data, isLoading, error } = useAxios(url);
  const [blogs, setBlogs] = useState([]);

  const { data2, isLoading2, error2 } = useAxios3(url2);
  const [blogs2, setBlogs2] = useState([]);

  const [pagin, setPagin] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);
  const [pagin_mov, setPagin_mov] = useState([1, 2, 3, 4, 5]);

  const [inputVal, setInputVal] = useState("");
  const [activeImage, setActiveImagen] = useState(null);

  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const formatDate = (date) => {
    const options = { day: "numeric", month: "long", year: "numeric" };
    return new Date(date).toLocaleDateString(i18n.language, options);
  };
  const handleImageClick = (index) => {
    setActiveImagen(index === activeImage ? null : index);
  };

  const options = [
    { value: "Desc", label: t("filtro.ordenar-fecha-op1") },
    { value: "Asce", label: t("filtro.ordenar-fecha-op2") },
  ];
  const categories = [
    {
      id: 1,
      name: i18n.language === "es" ? "Libertad" : "Liberty",
      image: "libertad",
    },
    {
      id: 2,
      name: i18n.language === "es" ? "Educacion" : "Education",
      image: "educacion",
    },
    {
      id: 3,
      name: i18n.language === "es" ? "Arte y Cultura" : "Art and Culture",
      image: "arte-y-cultura",
    },
    {
      id: 4,
      name: i18n.language === "es" ? "Liderazgo" : "Leadership",
      image: "liderazgo",
    },
    {
      id: 5,
      name: i18n.language === "es" ? "Innovacion" : "Innovation",
      image: "innovacion",
    },
    {
      id: 6,
      name: i18n.language === "es" ? "Estado de Derecho" : "Rule of Law",
      image: "estado-de-derecho",
    },
    {
      id: 7,
      name:
        i18n.language === "es"
          ? "Prosperidad Incluyente"
          : "Inclusive Prosperity",
      image: "prosperidad-incluyente",
    },
    {
      id: 8,
      name: i18n.language === "es" ? "Biblioteca" : "Library",
      image: "biblioteca",
    },
    {
      id: 9,
      name: i18n.language === "es" ? "Medio" : "Environment",
      image: "medio-ambiente",
    },
  ];

  //Lenguaje

  useEffect(() => {
    if (data) {
      setBlogs(data);
    }
  }, [data]);

  useEffect(() => {
    if (data2) {
      setBlogs2(data2);
      const i = Math.ceil(data2.length / 12);
      const newPagin = Array.from({ length: i }, (_, index) => index + 1);

      const i_mov = Math.ceil(data2.length / 6);

      setPagin(newPagin);
      if (i_mov <= 5) {
        const newPagin2 = Array.from(
          { length: i_mov },
          (_, index) => index + 1
        );
        setPagin_mov(newPagin2);
        setToppage_mov(i_mov - 1);
      } else {
        setPagin_mov([1, 2, 3, 4, 5]);
        setToppage_mov(4);
      }

      if (i != 0) {
        setToppage(i - 1);
      } else {
        setToppage(0);
      }
    }
  }, [data2]);

  useEffect(() => {
    if (date === null) {
      if (inputVal.length === 0 && category === null) {
        setUrl(
          `/blogs/n?offset=${counter * ficha}&next=12&lang=${i18n.language}`
        );
        setUrl2(`/blogs/n?offset=0&next=1203&lang=${i18n.language}`);
      } else if (inputVal.length >= 1) {
        if (category === null) {
          setUrl(
            `/blogs/search/by-title?offset=${counter * ficha
            }&next=${ficha}&lang=${i18n.language}&words=${inputVal}`
          );
          setUrl2(
            `/blogs/search/by-title?offset=0&next=1200&lang=${i18n.language}&words=${inputVal}`
          );
        } else {
          setUrl(
            `/blogs/search/by-title?offset=${counter * ficha
            }&next=${ficha}&lang=${i18n.language
            }&words=${inputVal}&category=${category}`
          );
          setUrl2(
            `/blogs/search/by-title?offset=0&next=1200&lang=${i18n.language}&words=${inputVal}&category=${category}`
          );
        }
      } else {
        setUrl(
          `/blogs/by-category/${category}?offset=${counter * ficha
          }&next=${ficha}&lang=${i18n.language}`
        );
        setUrl2(
          `/blogs/by-category/${category}?offset=0&next=1200&lang=${i18n.language}`
        );
      }
    } else {
      if (inputVal.length === 0 && category === null) {
        setUrl(
          `/blogs/n?offset=${counter * ficha}&next=12&lang=${i18n.language
          }&sort=${date}`
        );
        setUrl2(`/blogs/n?offset=0&next=1204&lang=${i18n.language}&sort=${date}`);
      } else if (inputVal.length >= 1) {
        if (category === null) {
          setUrl(
            `/blogs/search/by-title?offset=${counter * ficha
            }&next=${ficha}&lang=${i18n.language
            }&words=${inputVal}&sort=${date}`
          );
          setUrl2(
            `/blogs/search/by-title?offset=0&next=1200&lang=${i18n.language}&words=${inputVal}&sort=${date}`
          );
        } else {
          setUrl(
            `/blogs/search/by-title?offset=${counter * ficha
            }&next=${ficha}&lang=${i18n.language
            }&words=${inputVal}&category=${category}&sort=${date}`
          );
          setUrl2(
            `/blogs/search/by-title?offset=0&next=1200&lang=${i18n.language}&words=${inputVal}&category=${category}&sort=${date}`
          );
        }
      } else {
        setUrl(
          `/blogs/by-category/${category}?offset=${counter * ficha
          }&next=${ficha}&lang=${i18n.language}&sort=${date}`
        );
        setUrl2(
          `/blogs/by-category/${category}?offset=0&next=1200&lang=${i18n.language}&sort=${date}`
        );
      }
    }
  }, [counter, i18n.language]);


  //

  const notAllowedChars = [
    '"',
    "`",
    "=",
    ";",
    "[",
    "]",
    "{",
    "}",
    "/",
    "\\",
    "&",
    "<",
    ">",
    "'",
  ];

  const handleInputChange = (event) => {
    setInputVal(event.target.value);

    const value = event.target.value;

    // Verificar si el valor contiene algún carácter no permitido
    const containsNotAllowedChars = notAllowedChars.some((char) =>
      value.includes(char)
    );
    let cleanBody = "";

    if (containsNotAllowedChars) {
      event.target.classList.add("invalid");
      for (let character of inputVal) {
        cleanBody += notAllowedChars.includes(character) ? "" : character;
      }
      setInputVal(cleanBody);
    } else {
      event.target.classList.remove("invalid");
    }
  };
  //para movil
  const handleInputChange2 = (event) => {
    setInputVal(event.target.value);
  };

  const handleSelectChange = (event) => {
    //console.log('a', event)
    //console.log('Selected value:', event.target.value);
    handleDate(event);
  };

  function isMobile() {
    return window.innerWidth <= 768; // Puedes ajustar este valor según tus necesidades
  }

  const handleClick = () => {
    // Aquí puedes acceder al valor del input, que está en 'inputValue'
    if (inputVal.length <= 1) return;
    setFicha(12);
    setUrl(
      `/blogs/search/by-title?offset=0&next=${ficha}&lang=${i18n.language}&words=${inputVal}`
    );
    setUrl2(
      `/blogs/search/by-title?offset=0&next=1200&lang=${i18n.language}&words=${inputVal}`
    );
    setTxtbusqueda(inputVal);

    defaultValue(0);
    goToPage(0);

    const targetDivMobile = document.getElementById('id-resultadoss');
    const targetDivDesktop = document.getElementById('id-resultadosesc');

    // Si el div existe, hacer el desplazamiento
    if (isMobile() || !targetDivDesktop) {
      if (targetDivMobile) {
        targetDivMobile.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      if (targetDivDesktop) {
        targetDivDesktop.scrollIntoView({ behavior: 'smooth' });
      }
    }

  };

  const handleKeyDown = (e) => {
    // Verificar si la tecla presionada es "Enter" (código 13)
    if (e.key === "Enter") {
      handleClick();
    }
  };

  const handleClickDefault = (value) => {
    setFicha(value);
    setInputVal("");
    resetCounter();
    setUrl(`/blogs/n?offset=${counter * ficha}&next=12&lang=${i18n.language}`);
    setUrl2(`/blogs/n?offset=0&next=1202&lang=${i18n.language}`);
    setTxtbusqueda("");
  };

  const handleClick2 = () => {
    // Aquí puedes acceder al valor del input, que está en 'inputValue'
    if (inputVal.length <= 1) return;
    setFicha(6);
    setUrl(
      `/blogs/search/by-title?offset=0&next=${ficha}&lang=${i18n.language}&words=${inputVal}&category=${category}`
    );
    setUrl2(
      `/blogs/search/by-title?offset=0&next=600&lang=${i18n.language}&words=${inputVal}&category=${category}`
    );
  };

  function handleCategory(category) {
    if (inputVal.length >= 1) {
      if (category === null) {
        setUrl(
          `/blogs/search/by-title?offset=0&next=${ficha}&lang=${i18n.language}&words=${inputVal}`
        );
        setUrl2(
          `/blogs/search/by-title?offset=0&next=1200&lang=${i18n.language}&words=${inputVal}`
        );
      } else {
        setUrl(
          `/blogs/search/by-title?offset=0&next=${ficha}&lang=${i18n.language}&words=${inputVal}&category=${category}`
        );
        setUrl2(
          `/blogs/search/by-title?offset=0&next=1200&lang=${i18n.language}&words=${inputVal}&category=${category}`
        );
      }
    } else {
      setUrl(
        `/blogs/by-category/${category}?offset=0&next=${ficha}&lang=${i18n.language}`
      );
      setUrl2(
        `/blogs/by-category/${category}?offset=0&next=1200&lang=${i18n.language}`
      );
    }
    setCategory(category);
    resetCounter();
  }

  function handleDate(date) {
    if (inputVal.length === 0 && category === null) {
      setUrl(
        `/blogs/n?offset=${counter * ficha}&next=12&lang=${i18n.language
        }&sort=${date}`
      );
    } else {
      if (inputVal.length >= 1) {
        if (category === null) {
          setUrl(
            `/blogs/search/by-title?offset=0&next=${ficha}&lang=${i18n.language}&words=${inputVal}&sort=${date}`
          );
          setUrl2(
            `/blogs/search/by-title?offset=0&next=1200&lang=${i18n.language}&words=${inputVal}&sort=${date}`
          );
        } else {
          setUrl(
            `/blogs/search/by-title?offset=0&next=${ficha}&lang=${i18n.language}&words=${inputVal}&category=${category}&sort=${date}`
          );
          setUrl2(
            `/blogs/search/by-title?offset=0&next=1200&lang=${i18n.language}&words=${inputVal}&category=${category}&sort=${date}`
          );
        }
      } else {
        setUrl(
          `/blogs/by-category/${category}?offset=0&next=${ficha}&lang=${i18n.language}&sort=${date}`
        );
        setUrl2(
          `/blogs/by-category/${category}?offset=0&next=1200&lang=${i18n.language}&sort=${date}`
        );
      }
    }
    setDate(date);
  }

  const numero = (txtresumen) => {
    // Verificar si txtresumen es una cadena y no es undefined
    if (typeof txtresumen === 'string' && txtresumen.trim() !== '') {
      // Realizar split por "||"
      const partes = txtresumen.split("||");

      // Verificar si hay una segunda parte
      if (partes.length > 1 && partes[1].trim() !== "") {
        return partes[1].trim(); // Si hay una segunda parte, retornarla
      }
    }

    // Si no hay una segunda parte o si txtresumen no es una cadena o es vacío,
    // realizar el cálculo actual
    const i = Math.floor(Math.random() * 5) + 1;
    return i;
  };

  const resumensplit = (txtresumen) => {
    // Verificar si txtresumen es una cadena y no es undefined
    if (typeof txtresumen === 'string' && txtresumen.trim() !== '') {
      // Realizar split por "||"
      const partes = txtresumen.split("||");

      // Verificar si hay una segunda parte
      if (partes.length > 1 && partes[0].trim() !== "") {
        return partes[0].trim(); // Si hay una segunda parte, retornarla
      }
    }

    return txtresumen;
  };

  const [showOptions, setShowOptions] = useState(false);
  const [orderValue, setOrderValue] = useState("");


  useEffect(() => { }, [inputVal]);

  const fechData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}` + url2
      );
      const data = response.data;
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const elementosMostrados = 6;
  const [totalElementos, setTotalElementos] = useState([]);
  const totalPaginas = Math.ceil(blogs2?.length / elementosMostrados);
  const [paginaActual, setPaginaActual] = useState(1);
  const [paginasVisibles, setPaginasVisibles] = useState([]);

  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(pagin?.length / itemsPerPage);

  const goToPage = page => {
    setCurrentPage(page);
  };

  const nextButton = vble => {
    if (window.innerWidth <= 768) {
      // Lógica para dispositivos móviles (ancho menor o igual a 768px)
      if (paginaActual != totalPaginas) {
        setFicha(6);
        increment();
        nextPage();
        const targetDivMobile = document.getElementById('id-resultadoss');
        targetDivMobile.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Lógica para desktop (ancho mayor a 768px)
      if (counter < toppage) {
        setFicha(12)
        var_img.current = 0;
        setLoadingimg(true);
        increment();
        setCurrentPage(currentPage + 1);
        const targetDivDesktop = document.getElementById('id-resultadosesc');
        targetDivDesktop.scrollIntoView({ behavior: 'smooth' });
      }
    }

  };

  {/*useEffect(() => {
    const elementos = async () => {
      const data = await fechData();
      console.log(data);
      setTotalElementos(data);
    };
    elementos();
  }, []);*/}

  useEffect(() => {
    const generarPaginasVisibles = () => {
      let paginaInicial, paginaFinal;

      // Caso 1: Menos de 5 páginas en total
      if (totalPaginas <= 5) {
        paginaInicial = 1;
        paginaFinal = totalPaginas;
      } else {
        // Caso 2: Más de 5 páginas en total
        if (paginaActual < 5) {
          // Estamos en las primeras 5 páginas
          paginaInicial = 1;
          paginaFinal = 5;
        } else if (paginaActual + 4 >= totalPaginas) {
          // Estamos en las últimas 5 páginas
          paginaInicial = totalPaginas - 4;
          paginaFinal = totalPaginas;
        } else {
          // Estamos en el medio de las páginas
          paginaInicial = paginaActual - 2;
          paginaFinal = paginaActual + 2;
        }
      }

      // Generar la lista de páginas visibles
      const paginas = [];
      for (let i = paginaInicial; i <= paginaFinal; i++) {
        paginas.push(i);
      }

      setPaginasVisibles(paginas);
    };

    generarPaginasVisibles();
  }, [paginaActual, totalPaginas]);

  const nextPage = () => {
    setPaginaActual(
      paginaActual === totalPaginas ? totalPaginas : paginaActual + 1
    );
  };

  const prevPage = () => {
    setPaginaActual(paginaActual === 1 ? 1 : paginaActual - 1);
  };

  const [loadingimg, setLoadingimg] = useState(true);
  const var_img = useRef(0);
  const imageLoaded = () => {
    var_img.current += 1;
    if (var_img.current >= data.length) {
      setLoadingimg(false);
    }
  }

  const clearSearch = () => {
    setInputVal('');
  };


  return (
    <>
      <div className="contenedor_FiIdeLi escritorio">
        <div id="tocategory" className="filter-container-b">
          <div className="filter-column-b">
            <p style={{ marginBottom: "10px" }}>{t("filtro.algo-mente")}</p>
            <div id="input">
              <input
                type="text"
                placeholder={t("filtro.ingresa-tema-PH")}
                value={inputVal}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
              />
              {inputVal && (
                <button
                  onClick={clearSearch}
                  style={{
                    position: 'absolute',
                    right: '55px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '24px',
                    color: '#888',
                  }}
                >
                  &#x2715; {/* Esto es el símbolo de "X" */}
                </button>
              )}
              <img src={lupa} onClick={handleClick} />
            </div>
          </div>
          <div className="filter-column-b">
            <p style={{ marginBottom: "10px" }}>{t("filtro.ordenar-fecha")}</p>
            <div id="input">
              <div id="order-value">{orderValue}</div>
              <img
                id="arrow-image"
                src={arrowDownIcon}
                onClick={() => {
                  setShowOptions(!showOptions);
                }}
              />
              <div
                id="options-container"
                className={!showOptions ? "disabled" : ""}
              >
                <div
                  className="not-last"
                  onClick={(e) => {
                    setOrderValue(options[0].label);
                    handleSelectChange(options[0].value);
                    setShowOptions(false);
                  }}
                >
                  <p onClick={(e) => { }}>{options[0].label}</p>
                </div>
                <div
                  onClick={(e) => {
                    setOrderValue(options[1].label);
                    handleSelectChange(options[1].value);
                    setShowOptions(false);
                  }}
                >
                  <p onClick={(e) => { }}>{options[1].label}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="filter-column-b filter-column-b2">
            <p style={{ color: "white", marginBottom: "0.5em" }}>
              {t("ideaCort.filtr2")}
            </p>
            <button
              className="buton_IC"
              onClick={() => {
                handleClickDefault(12);
              }}
            >
              {t("filtro.todas-entradas")}
            </button>
          </div>
        </div>
        <div className="row_FiIdeLi1">
          <div className="row_FiIdeLi3">
            <p className="parraf">{t("filtro.ordenar-categoria")}</p>
          </div>
          <div className="row_FiIdeLi4">
            <div className="col1_FiIdeLi">
              <img
                src={liber}
                alt="Libertad"
                className={`categ categ_liber${activeImage === 1 ? "active" : ""
                  }`}
                onClick={() => {
                  setFicha(12);
                  handleCategory("Libertad");
                  handleImageClick(1);
                  goToPage(0);
                }}
                onLoad={
                  categoria === "libertad"
                    ? () => {
                      setTimeout(() => {
                        setFicha(12);
                        handleCategory("Libertad");
                        handleImageClick(1);
                      }, 1000); // Espera de 1 segundo (1000 milisegundos)
                    }
                    : null
                }
                data-tooltip-id="tooltip-section1"
                data-tooltip-content={t("categorias.categoria-1")}
                data-tooltip-place="top"
              />
              <Tooltip
                id="tooltip-section1"
                className="customTooltip"
                arrowColor="transparent"
              />
            </div>
            <div id="id-resultadosesc" className="col1_FiIdeLi">
              <img
                src={edu}
                alt="Educacion"
                className={`categ categ_educ${activeImage === 2 ? "active" : ""
                  }`}
                onClick={() => {
                  setFicha(12);
                  handleCategory("Educacion");
                  handleImageClick(2);
                  goToPage(0);
                }}
                onLoad={
                  categoria === "educacion"
                    ? () => {
                      setTimeout(() => {
                        setFicha(12);
                        handleCategory("Educacion");
                        handleImageClick(2);
                      }, 1000); // Espera de 1 segundo (1000 milisegundos)
                    }
                    : null
                }
                data-tooltip-id="tooltip-section1"
                data-tooltip-content={t("categorias.categoria-2")}
                data-tooltip-place="top"
              />
            </div>
            <div className="col1_FiIdeLi">
              <img
                src={arte}
                alt="Arte"
                className={`categ categ_arte${activeImage === 3 ? "active" : ""
                  }`}
                onClick={() => {
                  setFicha(12);
                  handleCategory("arte-y-cultura");
                  handleImageClick(3);
                  goToPage(0);
                }}
                onLoad={
                  categoria === "arte-y-cultura"
                    ? () => {
                      setTimeout(() => {
                        setFicha(12);
                        handleCategory("arte-y-cultura");
                        handleImageClick(3);
                      }, 1000); // Espera de 1 segundo (1000 milisegundos)
                    }
                    : null
                }
                data-tooltip-id="tooltip-section1"
                data-tooltip-content={t("categorias.categoria-3")}
                data-tooltip-place="top"
              />
            </div>
            <div className="col1_FiIdeLi">
              <img
                src={lider}
                alt="Liderazgo"
                className={`categ categ_lider${activeImage === 4 ? "active" : ""
                  }`}
                onClick={() => {
                  setFicha(12);

                  handleCategory("Liderazgo");
                  handleImageClick(4);
                  goToPage(0);
                }}
                onLoad={
                  categoria === "liderazgo"
                    ? () => {
                      setTimeout(() => {
                        setFicha(12);
                        handleCategory("Liderazgo");
                        handleImageClick(4);
                      }, 1000); // Espera de 1 segundo (1000 milisegundos)
                    }
                    : null
                }
                data-tooltip-id="tooltip-section1"
                data-tooltip-content={t("categorias.categoria-5")}
                data-tooltip-place="top"
              />
            </div>
            <div className="col1_FiIdeLi">
              <img
                src={inov}
                alt="Inovacion"
                className={`categ categ_ino${activeImage === 5 ? "active" : ""
                  }`}
                onClick={() => {
                  setFicha(12);
                  handleCategory("innovacion");
                  handleImageClick(5);
                  goToPage(0);
                }}
                onLoad={
                  categoria === "innovacion"
                    ? () => {
                      setTimeout(() => {
                        setFicha(12);
                        handleCategory("innovacion");
                        handleImageClick(5);
                      }, 1000); // Espera de 1 segundo (1000 milisegundos)
                    }
                    : null
                }
                data-tooltip-id="tooltip-section1"
                data-tooltip-content={t("categorias.categoria-6")}
                data-tooltip-place="top"
              />
            </div>

            <div className="col1_FiIdeLi">
              <img
                src={dere}
                alt="Derecho"
                className={`categ categ_dere${activeImage === 6 ? "active" : ""
                  }`}
                onClick={() => {
                  setFicha(12);
                  handleCategory("estado-de-derecho");
                  handleImageClick(6);
                  goToPage(0);
                }}
                onLoad={
                  categoria === "estado-de-derecho"
                    ? () => {
                      setTimeout(() => {
                        setFicha(12);
                        handleCategory("estado-de-derecho");
                        handleImageClick(6);
                      }, 1000); // Espera de 1 segundo (1000 milisegundos)
                    }
                    : null
                }
                data-tooltip-id="tooltip-section1"
                data-tooltip-content={t("categorias.categoria-7")}
                data-tooltip-place="top"
              />
            </div>
            <div className="col1_FiIdeLi">
              <img
                src={prosp}
                alt="Prosperidad"
                className={`categ categ_prosp${activeImage === 7 ? "active" : ""
                  }`}
                onClick={() => {
                  setFicha(12);
                  handleCategory("prosperidad-incluyente");
                  handleImageClick(7);
                  goToPage(0);
                }}
                onLoad={
                  categoria === "prosperidad-incluyente"
                    ? () => {
                      setTimeout(() => {
                        setFicha(12);
                        handleCategory("prosperidad-incluyente");
                        handleImageClick(7);
                      }, 1000);
                    }
                    : null
                }
                data-tooltip-id="tooltip-section1"
                data-tooltip-content={t("categorias.categoria-9")}
                data-tooltip-place="top"
              />
            </div>
            <div className="col1_FiIdeLi">
              <img
                src={biblio}
                alt="Biblioteca"
                className={`categ categ_biblio${activeImage === 8 ? "active" : ""
                  }`}
                onClick={() => {
                  setFicha(12);

                  handleCategory("biblioteca");
                  handleImageClick(8);
                  goToPage(0);
                }}
                onLoad={
                  categoria === "biblioteca"
                    ? () => {
                      setTimeout(() => {
                        setFicha(12);
                        handleCategory("biblioteca");
                        handleImageClick(8);
                      }, 1000);
                    }
                    : null
                }
                data-tooltip-id="tooltip-section1"
                data-tooltip-content={t("categorias.categoria-8")}
                data-tooltip-place="top"
              />
            </div>
            <div className="col1_FiIdeLi">
              <img
                src={medio}
                alt="Medio"
                className={`categ categ_medio${activeImage === 9 ? "active" : ""
                  }`}
                onClick={() => {
                  setFicha(12);
                  handleCategory("medio-ambiente");
                  handleImageClick(9);
                  goToPage(0);
                }}
                onLoad={
                  categoria === "medio-ambiente"
                    ? () => {
                      setTimeout(() => {
                        setFicha(12);
                        handleCategory("medio-ambiente");
                        handleImageClick(9);
                      }, 1000);
                    }
                    : null
                }
                data-tooltip-id="tooltip-section1"
                data-tooltip-content={t("categorias.categoria-4")}
                data-tooltip-place="top"
              />
            </div>
          </div>
        </div>
      </div>

      {/* movil mas chiquito */}
      <div className="movil2">
        <div className="filter-container-b filter-con-top-d">
          <div className="filter-column-b">
            <p>{t("filtro.algo-mente")}</p>
          </div>
        </div>
      </div>

      <div className={`movil2 mov-mar-top ${isVisible ? 'visible23' : 'hidden23'}`}>
        <div className="filter-container-b filter-container-b22">
          <div className="filter-column-b">

            <div id="input">
              <input
                type="text"
                placeholder={t("filtro.ingresa-tema-PH")}
                value={inputVal}
                onChange={handleInputChange}
              />
              {inputVal && (
                <button
                  onClick={clearSearch}
                  style={{
                    position: 'absolute',
                    right: '55px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '24px',
                    color: '#888',
                  }}
                >
                  &#x2715; {/* Esto es el símbolo de "X" */}
                </button>
              )}
              <img src={lupa} onClick={handleClick} />
            </div>
          </div>

          <div className="filter-column-b">
            <p className="ord-mov-txt">{t("filtro.ordenar-fecha")}</p>
            <div id="input">
              <div id="order-value">{orderValue}</div>
              <img
                id="arrow-image2"
                src={arrowDownIcon}
                onClick={() => {
                  setShowOptions(!showOptions);
                }}
              />
              <div
                id="options-container2"
                className={!showOptions ? "disabled" : ""}
              >
                <div
                  className="not-last"
                  onClick={(e) => {
                    setOrderValue(options[0].label);
                    handleSelectChange(options[0].value);
                  }}
                >
                  <p
                    onClick={(e) => {
                      setOrderValue(options[0].label);
                      handleSelectChange(options[0].value);
                    }}
                  >
                    {options[0].label}
                  </p>
                </div>
                <div
                  onClick={(e) => {
                    setOrderValue(options[1].label);
                    handleSelectChange(options[1].value);
                  }}
                >
                  <p
                    onClick={(e) => {
                      setOrderValue(options[1].label);
                      handleSelectChange(options[1].value);
                    }}
                  >
                    {options[1].label}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="filter-column-b">
            <div id="h"></div>
            <button
              className="buton_IC"
              onClick={() => {
                handleClickDefault(6);
              }}
            >
              {t("filtro.todas-entradas")}
            </button>
          </div>
        </div>

        <div className="IC_reng6">
          <p className="parraf">{t("filtro.ordenar-categoria")}</p>
        </div>

        <div className="IC0">
          <div className="IC_reng7_1">
            <img
              src={liber}
              alt="Imagen libro"
              className={`categ categ_liber${activeImage === 1 ? "active" : ""
                }`}
              onClick={() => {
                setFicha(6);
                handleCategory("Libertad");
                handleImageClick(1);
                goToPage(0);
                setPaginaActual(1);
              }}
            // onLoad={
            //   categoria === "libertad"
            //     ? () => {
            //       setFicha(6);
            //       handleCategory("Libertad");
            //       handleImageClick(1);
            //     }
            //     : null
            // }
            // className={`categ categ_liber${activeImage ===1 ? 'active': ''}`}
            />
            <p className="parraf">{t("catego2.freedom")}</p>
          </div>

          <div className="IC_reng7_2">
            <img
              src={edu}
              alt="Imagen libro"
              className="categ "
              onClick={() => {
                setFicha(6);
                handleCategory("Educacion");
                handleImageClick(2);
                goToPage(0);
                setPaginaActual(1);
              }}
            // onLoad={
            //   categoria === "educacion"
            //     ? () => {
            //       setFicha(6);
            //       handleCategory("Educacion");
            //       handleImageClick(2);
            //     }
            //     : null
            // }
            />
            <p className="parraf">{t("catego2.education")}</p>
          </div>

          <div className="IC_reng7_3">
            <img
              src={arte}
              alt="Imagen libro"
              className={`categ categ_arte${activeImage === 3 ? "active" : ""}`}
              onClick={() => {
                setFicha(6);
                handleCategory("arte-y-cultura");
                handleImageClick(3);
                goToPage(0);
                setPaginaActual(1);
              }}
            // onLoad={
            //   categoria === "arte-y-cultura"
            //     ? () => {
            //       setFicha(6);
            //       handleCategory("arte-y-cultura");
            //       handleImageClick(3);
            //     }
            //     : null
            // }
            />
            <p className="parraf">
              {t("catego2.art-and")}
              <br className="br_mov"></br>
              {t("catego2.culture")}
            </p>
          </div>
        </div>

        <div className="IC0">
          <div className="IC_reng8_1">
            <img
              src={lider}
              alt="Imagen libro"
              className={`categ categ_lider${activeImage === 4 ? "active" : ""
                }`}
              onClick={() => {
                setFicha(6);
                handleCategory("Liderazgo");
                handleImageClick(4);
                goToPage(0);
                setPaginaActual(1);
              }}
            // onLoad={
            //   categoria === "liderazgo"
            //     ? () => {
            //       setFicha(6);
            //       handleCategory("Liderazgo");
            //       handleImageClick(4);
            //     }
            //     : null
            // }
            />
            <p className="parraf">{t("catego2.leadership")}</p>
          </div>

          <div className="IC_reng8_2">
            <img
              src={inov}
              alt="Imagen libro"
              className={`categ categ_ino${activeImage === 5 ? "active" : ""}`}
              onClick={() => {
                setFicha(6);
                handleCategory("innovacion");
                handleImageClick(5);
                goToPage(0);
                setPaginaActual(1);
              }}
            // onLoad={
            //   categoria === "innovacion"
            //     ? () => {
            //       setFicha(6);
            //       handleCategory("innovacion");
            //       handleImageClick(5);
            //     }
            //     : null
            // }
            />
            <p className="parraf">
              {t("catego2.inno")}
              <br />
              {t("catego2.emprend")}
            </p>
          </div>

          <div className="IC_reng8_3">
            <img
              src={dere}
              alt="Imagen libro"
              className={`categ categ_dere${activeImage === 6 ? "active" : ""}`}
              onClick={() => {
                setFicha(6);
                handleCategory("estado-de-derecho");
                handleImageClick(6);
                goToPage(0);
                setPaginaActual(1);
              }}
            // onLoad={
            //   categoria === "estado-de-derecho"
            //     ? () => {
            //       setFicha(6);
            //       handleCategory("estado-de-derecho");
            //       handleImageClick(6);
            //     }
            //     : null
            // }
            />
            <p className="parraf">
              {t("catego2.rule")}
              <br />
              {t("catego2.dere")}
            </p>
          </div>
        </div>

        <div className="IC0">
          <div className="IC_reng9_1">
            <img
              src={prosp}
              alt="Imagen libro"
              className={`categ categ_prosp${activeImage === 7 ? "active" : ""
                }`}
              onClick={() => {
                setFicha(6);
                handleCategory("prosperidad-incluyente");
                handleImageClick(7);
                goToPage(0);
                setPaginaActual(1);
              }}
            // onLoad={
            //   categoria === "prosperidad-incluyente"
            //     ? () => {
            //       setFicha(6);
            //       handleCategory("prosperidad-incluyente");
            //       handleImageClick(7);
            //     }
            //     : null
            // }
            />
            <p className="parraf">
              {t("catego2.prosperity")} <br />
              {t("catego2.inclusive")}
            </p>
          </div>

          <div className="IC_reng9_2">
            <img
              src={biblio}
              alt="Imagen libro"
              className={`categ categ_biblio${activeImage === 8 ? "active" : ""
                }`}
              onClick={() => {
                setFicha(6);
                handleCategory("biblioteca");
                handleImageClick(8);
                goToPage(0);
                setPaginaActual(1);
              }}
            // onLoad={
            //   categoria === "biblioteca"
            //     ? () => {
            //       setFicha(6);
            //       handleCategory("biblioteca");
            //       handleImageClick(8);
            //     }
            //     : null
            // }
            />
            <p className="parraf">{t("catego2.Biblio")}</p>
          </div>

          <div className="IC_reng9_3">
            <img
              src={medio}
              alt="Imagen libro"
              className={`categ categ_medio${activeImage === 9 ? "active" : ""
                }`}
              onClick={() => {
                setFicha(6);
                handleCategory("medio-ambiente");
                handleImageClick(9);
                goToPage(0);
                setPaginaActual(1);
              }}
            // onLoad={
            //   categoria === "medio-ambiente"
            //     ? () => {
            //       setFicha(6);
            //       handleCategory("medio-ambiente");
            //       handleImageClick(9);
            //     }
            //     : null
            // }
            />
            <p className="parraf">
              {t("catego2.medio")}
              <br />
              {t("catego2.ambiente")}
            </p>
          </div>
        </div>

        <div className="div1"></div>
      </div>

      <div id="id-resultadoss" className="movil2 btn-tog-down">
        <div className="filter-column-b">

          <button className="btn-tog" onClick={toggleVisibility}>
            <img
              className={isVisible ? 'rotated' : ''} // Aplica la clase 'rotated' cuando isVisible es true
              src={lupa}
            />
          </button>
        </div>
        <div className="line"></div>
      </div>

      {isLoading ? (
        <h1 style={{ marginLeft: "45%" }}> Cargando... </h1>
      ) : (
        <>
          {txtbusqueda && (
            <>
              <h4 id="ancla1">{t("filtro.resultados")} <span>{txtbusqueda}</span></h4>
              <div className="rest_res">
                {blogs.length > 0 ? (
                  <>
                    {blogs.length == 1 ? (
                      <a href="#ancla1">{blogs2.length} Blog {t("filtro.resultados1")}</a>
                    ) : (
                      <a href="#ancla1">{blogs2.length} Blogs {t("filtro.resultados1")}</a>
                    )}
                  </>
                ) : (
                  <a className="disable">{blogs2.length} Blogs {t("filtro.resultados1")}</a>
                )
                }

                {variableRetornada > 0 ? (
                  <>
                    {variableRetornada == 1 ? (
                      <a href="#ancla2">{variableRetornada} Blog {t("filtro.resultados2")}</a>
                    ) : (
                      <a href="#ancla2">{variableRetornada} Blogs {t("filtro.resultados2")}</a>
                    )}
                  </>
                ) : (
                  <a className="disable">{variableRetornada} Blogs {t("filtro.resultados2")}</a>
                )
                }


              </div>

            </>
          )}
          {blogs.length > 0 ? (
            <>
              {txtbusqueda && (
                <h4 className="busquedadiv"><span className="yellow">Blogs {t("filtro.resultados1")}</span></h4>
              )}
              <div className="contenedor_LisBlog escritorio">
                <div className="row1_LB">
                  <p className="result">
                    {t("filtro.mostrar-resultados1")} {((counter) * 12) + (blogs ? blogs.length : 0)}{t2("biblioteca.of")}{(blogs2 ? blogs2.length : 60)}{" "}
                    {t("filtro.mostrar-resultados2")}
                  </p>
                </div>

                <div className="row2_LB">
                  <div style={{ display: loadingimg ? "block" : "none" }}>
                    <h1 style={{ marginLeft: "45%" }}> Cargando... </h1>
                  </div>
                  <div style={{ display: loadingimg ? "none" : "flex" }} className="list_content--items">
                    {blogs.map((item, index) => {

                      return (
                        <div key={index} className="card">
                          <div className="front">
                            <img
                              className="imgG_LB"
                              src={item.urlImagen}
                              alt={item.urlImagen}
                              onLoad={imageLoaded}
                            />
                            <div className="cinta">
                              <p className="tit_LB">{item.titulo}</p>
                            </div>
                          </div>

                          <div className="back">
                            {/* <p className="fh_ub">{formatDate(blogs[0].fecha)}</p> */}

                            {/* <p className="fh_LB"> {item.fecha.substring(0, 10)}  </p> */}
                            <p className="fh_LB"> {formatDate(item.fecha)} </p>
                            <p className="catego">
                              {item.categorias.map((dat) => dat.nombre).join(" - ")}
                            </p>
                            <hr className="line_LB"></hr>
                            <p className="titu_LB">
                              {item.titulo}
                              <p className="titu_LB2">{t("filtro.por-rbs")}</p>
                            </p>
                            <p className="desc_LB">
                              {resumensplit(item.resumen).substring(0, 100) + "..."}
                            </p>
                            <img className="reloj_LB " src={rel} alt="reloj"></img>
                            <p className="alineIzq_ub_LB">
                              {" "}
                              {numero(item.resumen)} {t("filtro.tiempo-lectura")}
                            </p>

                            <div className="div_bot_LB">
                              {txtbusqueda || category ? (
                                <a className="buton_LB" target="_blank" href={"/blog/" + item.tag}>
                                  {t("filtro.leer")}
                                </a>
                              ) : (
                                <a className="buton_LB" href={"/blog/" + item.tag}>
                                  {t("filtro.leer")}
                                </a>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  <div id="column-left">
                    <div className="row6_LB" style={{ cursor: "pointer" }}>
                      <img
                        className="imgPag_LB"
                        onClick={() => {
                          console.log(counter);
                          console.log(toppage);
                          if (counter < toppage) {
                            setFicha(12)
                            var_img.current = 0;
                            setLoadingimg(true);
                            increment();
                            setCurrentPage(currentPage + 1);
                          }
                        }}
                        src={ir}
                        alt="ir"
                      />
                    </div>
                    <div
                      className="row6_LB"
                      onClick={() => {
                        if (counter > 0) {
                          setFicha(12);
                          var_img.current = 0;
                          setLoadingimg(true);
                          decrement();
                          setCurrentPage(currentPage - 1);
                        }
                      }}
                    >
                      {counter > 0 ? (
                        <img
                          className="imgPag_LB cursorPointer"
                          src={regresa2}
                          alt="regresa"
                        />
                      ) : (
                        <img className="imgPag_LB" src={regresa} alt="regresa" />
                      )}
                    </div>

                    {pagin.slice(currentPage > 3 ? currentPage - 3 : 0, currentPage > 3 ? currentPage + itemsPerPage - 3 : 10)
                      .map((item, index) => (
                        <div
                          key={index}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setFicha(12);
                            var_img.current = 0;
                            setLoadingimg(true);
                            defaultValue(item - 1);
                            goToPage(item - 1);
                          }}
                          div
                          className="row6_LB"
                        >
                          <p
                            className={
                              item - 1 === currentPage
                                ? "nume numeros_paginado_idea_corta"
                                : "nume"
                            }
                          >
                            {item}
                          </p>
                        </div>
                      ))}
                  </div>
                </div>
                <div className="row3_LB">
                  <p className="result">
                    {t("filtro.mostrar-resultados1")} {((counter) * 12) + (blogs ? blogs.length : 0)}{t2("biblioteca.of")}{(blogs2 ? blogs2.length : 60)}{" "}
                    {t("filtro.mostrar-resultados2")}
                  </p>
                </div>
              </div>
              <div className="contenedor_LisBlog movil">
                <div className="column-arriba">
                  <div className="media-val">
                    <p className="result">
                      {t("filtro.mostrar-resultados1")} {((counter) * 6) + (blogs ? blogs.slice(0, 6).length : 0)}{t2("biblioteca.of")}<span className="esp_lblog"><br></br></span>{(blogs2 ? blogs2.length : 60)}{" "}
                      {t("filtro.mostrar-resultados2")}
                    </p>
                  </div>
                  <div class="contenedor-paginacion-movil">
                    {/* Boton para ir hacia atras */}
                    <div className="contenedor-btn">
                      <img
                        className="imagen-izquierda"
                        onClick={() => {
                          if (paginaActual != 1) {
                            setFicha(6);
                            decrement();
                            prevPage();
                          }
                        }}
                        src={`${paginaActual > 1
                          ? "/assets/imgs/detalle_blog/arrow.png"
                          : "/assets/imgs/detalle_blog/regresa.png"
                          }`}
                        disabled={paginaActual === 1 ? true : false}
                      />
                    </div>

                    {/* Ellipisis para mostrar si es mas de las 5 primeras */}
                    {paginaActual >= 5 && <a>...</a>}

                    {/* Paginas visibles */}
                    {paginasVisibles.map((page) => (
                      <a
                        key={page}
                        className={`${page === paginaActual
                          ? "active numeros_paginado_idea_corta_movil"
                          : ""
                          }`}
                        onClick={() => {
                          setFicha(6);
                          defaultValue(page - 1);
                          setPaginaActual(page);
                        }}
                      >
                        {page}
                      </a>
                    ))}
                    {/* Ellipisis para mostrar si no es las 5 ultimas */}
                    {paginaActual < totalPaginas - 4 ? null : <a>...</a>}

                    {/* Boton para ir hacia adelante */}
                    <div className="contenedor-btn">
                      <img
                        className="imagen-derecha"
                        onClick={() => {
                          if (paginaActual != totalPaginas) {

                            setFicha(6);
                            increment();
                            nextPage();
                          }
                        }}
                        src={`${paginaActual === totalPaginas
                          ? "/assets/imgs/detalle_blog/ir_2.png"
                          : "/assets/imgs/detalle_blog/ir_acti.png "
                          }`}
                        disabled={paginaActual === totalPaginas ? true : false}
                      />
                    </div>
                  </div>
                </div>

                <div className="row2_LB">
                  <div className="list_content--items">
                    {blogs.slice(0, 6).map((item, index) => (
                      // blogs.map((item, index) => (

                      <div key={index} className="card">
                        <div className="front">
                          <img
                            className="imgG_LB"
                            src={item.urlImagen}
                            alt={item.urlImagen}
                          />
                          <div className="cinta">
                            <p className="tit_LB">{item.titulo}</p>
                          </div>
                        </div>

                        <div className="back">
                          {/* <p className="fh_LB"> {item.fecha.substring(0, 10)}  </p> */}
                          <p className="fh_LB"> {formatDate(item.fecha)} </p>

                          <p className="catego">
                            {item.categorias.map((dat) => dat.nombre).join(" - ")}
                          </p>
                          <hr className="line_LB"></hr>
                          <p className="titu_LB">{item.titulo}</p>
                          <p className="desc_LB">
                            {resumensplit(item.resumen).substring(0, 100) + "..."}
                          </p>
                          <img className="reloj_LB " src={rel} alt="reloj"></img>
                          <p className="alineIzq_ub_LB">
                            {" "}
                            {numero(item.resumen)} {t("filtro.tiempo-lectura")}
                          </p>
                          <div className="div_bot_LB">
                            {txtbusqueda || category ? (
                              <a className="buton_LB" target="_blank" href={"/blog/" + item.tag}>
                                {t("filtro.leer")}
                              </a>
                            ) : (
                              <a className="buton_LB" href={"/blog/" + item.tag}>
                                {t("filtro.leer")}
                              </a>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="media-val22">
                  <p className="result">
                    {t("filtro.mostrar-resultados1")} {((counter) * 6) + (blogs ? blogs.slice(0, 6).length : 0)}{t2("biblioteca.of")}{(blogs2 ? blogs2.length : 60)}{" "}
                    {t("filtro.mostrar-resultados2")}
                  </p>
                </div>
              </div>
            </>



          ) : (
            <>
              {variableRetornada > 0 ? (
                <h4 className="no-encontrado">No se encontraron blogs relacionados con tu busqueda</h4>
              ) :
                (
                  <h4 className="no-encontrado2">No se encontraron blogs relacionados con tu busqueda</h4>
                )
              }

            </>
          )}

        </>
      )}


      {!txtbusqueda && (
        <div className="contenedor_LisBlog1">
          <div className="row4_LB">
            <div className="div_bot2_LB">
              <button className="navbar_suscribirse" onClick={() => nextButton('someValue')} disabled={paginaActual === totalPaginas ? true : false}>
                {t("filtro.mas-entradas")}
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="espacio-ancla" id="ancla2">

      </div>

      {txtbusqueda && (
        <Busqueda_cont cadena={txtbusqueda} catego={category} datee={null} onRetorno={handleRetorno} />
      )}

    </>
  );
};
export default ListBlog;
